import renderInputField from 'components/FormControls/textInput'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import emailValidator from 'utils/validators/emailValidator'
import * as Yup from 'yup'
import LoginField from '../subcomponents/LoginField'
import { useAccountCreateFormSubmit } from 'modules/Forms/Account/Create/useAccountCreateFormSubmit'
import FormFrame from 'modules/Forms/Account/Create/subcomponents/FormFrame'
import clsx from 'clsx'
import formStyles from 'modules/Forms/common-form.module.scss'

export const MytargetIntSchema = () =>
  Yup.object().shape({
    network: Yup.string().required('common::validation_messages.required'),
    email: Yup.string()
      .test('emailValidator', 'common::validation_messages.incorrect_email_format', emailValidator)
      .required('common::validation_messages.required'),
  })

let CreateMyTargetIntAccountForm = ({
  handleSubmit,
  submitting,
  onClose,
  autofill,
  networkId,
  form,
  initialValues,
  array,
  multiLogins,
  networkType,
}) => {
  const selector = formValueSelector(form)
  const { t } = useTranslation()
  const submitAccountData = useAccountCreateFormSubmit({ form, onClose, multiLogins, networkType })

  const { email, user } = useSelector((state) => ({
    email: selector(state, 'email'),
    user: state['app'].user,
  }))

  useEffect(() => {
    user.name && email === initialValues.email && autofill('email', user.name)
  }, [user])

  return (
    <FormFrame
      onSubmit={handleSubmit(submitAccountData)}
      multiLogins={multiLogins}
      form={form}
      submitAccountData={submitAccountData}
      submitting={submitting}
      onClose={onClose}
    >
      <Field
        disabled
        name="network"
        hidden
        fullWidth
        component={renderInputField}
        t={t}
      />

      <div className={clsx('margin-bottom-16', formStyles['row_with-tooltip'])}>
        <LoginField
          form={form}
          multiLogins={multiLogins}
          array={array}
          autofill={autofill}
          networkId={networkId}
          label={'services::forms.register_account.mytargetint.fields.login.label'}
        />
      </div>

      <div className={clsx('margin-bottom-16', formStyles['row_with-tooltip'])}>
        <Field
          name="email"
          type="email"
          fullWidth
          component={renderInputField}
          label={t('services::forms.register_account.mytargetint.fields.email.label')}
          t={t}
        />
      </div>
    </FormFrame>
  )
}

CreateMyTargetIntAccountForm = reduxForm({
  form: 'CreateMyTargetIntAccountForm',
  initialValues: {
    login: '',
    network: '',
    email: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
})(CreateMyTargetIntAccountForm)

CreateMyTargetIntAccountForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  onClose: PropTypes.func,
  autofill: PropTypes.func,
  networkId: PropTypes.string,
  initialValues: PropTypes.object,
  form: PropTypes.string,
  multiLogins: PropTypes.bool,
  array: PropTypes.object,
  networkType: PropTypes.string,
}

export default CreateMyTargetIntAccountForm
